import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DashboardTile from '../DashboardTile';
import { getProjects } from '../../services/projectService';

const ProponentDashboard = () => {
  const { user, memberships } = useAuth();
  const [myProjects, setMyProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProjects({ mine: true })
      .then((r) => setMyProjects(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const statusColor = { pending: '#F4B400', approved: '#0F9D58', rejected: '#ef4444', draft: '#94a3b8' };
  const activeCommunities = (memberships || []).filter((m) => m.status === 'active');

  return (
    <div className="panel-dashboard">
      <div className="panel-dashboard__header">
        <div>
          <h1>Proponent Dashboard</h1>
          <p>Welcome, {user?.firstName || user?.email}</p>
        </div>
        <Link to="/proponent" className="btn btn--primary">My Projects & Communities →</Link>
      </div>

      {/* Quick tiles */}
      <h2 className="panel-dashboard__section-title">Quick Actions</h2>
      <div className="tile-grid">
        <DashboardTile
          title="Submit a Project"
          icon="➕"
          description="Propose a new project to one of your communities"
          path="/proponent"
          color="#4285F4"
        />
        <DashboardTile
          title="My Communities"
          icon="🏘️"
          description={`Active in ${activeCommunities.length} communit${activeCommunities.length === 1 ? 'y' : 'ies'}`}
          path="/membership"
          color="#0F9D58"
        />
        <DashboardTile
          title="Find a Community"
          icon="🔍"
          description="Browse and join new communities on the platform"
          path="/tenants"
          color="#9C27B0"
        />
        <DashboardTile
          title="Consultations"
          icon="💬"
          description="Participate in active community consultations"
          path="/consultation"
          color="#F4B400"
        />
      </div>

      {/* Recent project submissions */}
      <h2 className="panel-dashboard__section-title">Recent Project Submissions</h2>
      {loading ? (
        <p style={{ color: '#64748b' }}>Loading…</p>
      ) : myProjects.length === 0 ? (
        <div className="empty-state">
          <p>No project submissions yet.</p>
          <Link to="/proponent" className="btn btn--secondary">Submit your first project →</Link>
        </div>
      ) : (
        <div className="proponent-project-list">
          {myProjects.slice(0, 5).map((p) => (
            <div key={p._id} className="proponent-project-row">
              <span className="proponent-project-title">{p.title}</span>
              <span className="proponent-project-community">
                {p.tenantId?.branding?.displayName || p.tenantId?.name || 'Unknown community'}
              </span>
              <span className="badge" style={{ background: statusColor[p.status] || '#94a3b8', color: '#fff' }}>
                {p.status}
              </span>
            </div>
          ))}
          {myProjects.length > 5 && (
            <Link to="/proponent" style={{ fontSize: '0.85rem', color: '#4285F4' }}>
              View all {myProjects.length} submissions →
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default ProponentDashboard;
